ixModuleRouting("impactx.demandbundle", {
    "/demandbundlelist": {
        template: "<ixa-demand-bundle-list></ixa-demand-bundle-list>",
        templateUrl: "modules/demandbundle/templates/demandbundlelist.html",
        process: "BundlePositions",
        controller: "DemandBundleListCtrl",
        controllerAs: "demandBundleListCtrl",
        workspace: "shop",
    },
    "/demandbundledonelist": {
        template: "<ixa-demand-bundle-done-list></ixa-demand-bundle-done-list>",
        templateUrl: "modules/demandbundle/templates/demandbundledonelist.html",
        process: "BundlePositions",
        controller: "DemandBundleDoneListCtrl",
        controllerAs: "demandBundleDoneListCtrl",
        workspace: "shop",
    },
    "/demandbundledetail/:id": {
        template: "<ixa-demand-bundle-detail></ixa-demand-bundle-detail>",
        templateUrl: "modules/demandbundle/templates/demandbundledetail.html",
        process: "BundlePositions",
        controller: "DemandBundleDetailCtrl",
        controllerAs: "statusCtrl",
        workspace: "shop",
    },
});
